import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Site, SiteForm } from '../models';

@Injectable({ providedIn: 'root' })
export class SiteService {

  sitesUrl = environment.dns + 'api/sites/';

  constructor(private http: HttpClient) { }

  getList(): Observable<Site[]> {
    return this.http.get<Site[]>(this.sitesUrl + 'list');
  }

  getListBySociety(societyId: number): Observable<Site[]> {
    return this.http.get<Site[]>(this.sitesUrl + 'list-by-society?societyId=' + societyId);
  }

  getListBySocietyAndType(societyId: number, type: string): Observable<Site[]> {
    return this.http.get<Site[]>(this.sitesUrl + 'list-by-society-and-type?societyId=' + societyId + '&type=' + type);
  }

  getOne(id: number): Observable<Site> {
    return this.http.get<Site>(this.sitesUrl + id);
  }

  add(siteForm: SiteForm): Observable<Site> {
    return this.http.post<Site>(this.sitesUrl, siteForm);
  }

  update(siteForm: SiteForm): Observable<Site> {
    return this.http.put<Site>(this.sitesUrl, siteForm);
  }

  delete(id: number): Observable<boolean> {
    return this.http.delete<boolean>(this.sitesUrl + id);
  }
}
